export const CURRENCY = 'currency';
export const NUMERIC = 'numeric';
export const PERCENTAGE = 'percentage';
